import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { Router } from "@angular/router";
import { TutorialService } from "app/auth/service/tutorial.service";
import { TicketService } from "../../ticket.service";
import { ICategoryTicket, IFile, IFileComplete } from "../../models/tickets";

@Component({
  selector: "app-open-ticket",
  templateUrl: "./open-ticket.component.html",
  styleUrls: ["./open-ticket.component.scss"],
})
export class OpenTicketComponent implements OnInit {
  @ViewChild("openTicketModal") openTicketModal;
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public note: string = "";
  public title: string = "";
  public category: number = null;
  public categoriesTicket: ICategoryTicket[] = [];
  public showErrors: boolean = false;
  public attachmentsListObj: IFile[] = [];
  public attachmentsList: IFile[] = [];

  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _ticketService: TicketService,
    private _routerService: Router,
    public _tutorialService: TutorialService,
  ) {}

  async ngOnInit() {
    await this._ticketService.getCategoriesList(true);
    this.categoriesTicket = this._ticketService.categoriesList;
    setTimeout(() => {
      this._modalService.open(this.openTicketModal, {
        centered: true,
        size: "lg",
        backdrop: false,
        keyboard: false,
      });
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.note = "";
    this._utilService.popupOpenTicketIsOpen = !this._utilService.popupOpenTicketIsOpen;
    this.showErrors = false;
    this.attachmentsListObj = [];
    this.attachmentsList = [];
  }

  async addAttachmentToList(files: IFileComplete[]) {
    // I create a variable from the actual list
    let updatedList: IFile[] = this.attachmentsListObj.filter((item: IFile) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (typeof file.size === "number" && file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: IFile = updatedList.find((item: IFile) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.filter((item: IFile) => item.name !== file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachmentsList.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(Number(file.size)),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachmentsListObj = updatedList;
  }

  removeAttachmentFromList(index_attachment: number) {
    this.attachmentsListObj = this.attachmentsListObj.filter((item: IFile, i: number) => i !== index_attachment);
    this.attachmentsList = this.attachmentsList.filter((item: IFile, i: number) => i !== index_attachment);
  }

  async sendTicket() {
    if (!!this.note) {
      this.note = this.note.trim();
    }
    if (!this.category || this.category < 1 || !this.note || this.note.length < 1) {
      this.showErrors = true;
      return false;
    }

    if (this.note.length < 4) {
      await this._utilService.showSWALError({ text: "INSERT_MIN_4_CHARACCTERS" });
      return false;
    }

    if (this.title.length < 4) {
      await this._utilService.showSWALError({ text: "ERRORS.FIELD_TITLE" });
      return false;
    }

    await this._utilService.showLoading();
    await this._ticketService
      .create({
        title: this.title.trim(),
        category: this.category,
        note: this.note.trim(),
      })
      .then(async (response: { id: number }) => {
        if (this.attachmentsList && this.attachmentsList.length > 0) {
          this._utilService.hideLoading();
          await this.uploadAttachments(response.id);
        }
        this.callbackFn.emit();
        if (!window.location.href.includes("/ticket/my-list")) {
          await this._routerService.navigateByUrl("/dashboard/ticket/my-list");
        } else {
          this._ticketService.getMineTicket();
        }
        this._utilService.hideLoading();
        this.modalClose();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_SUPPORT_REQUEST" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_SUPPORT_REQUEST" });
      });
  }

  async uploadAttachments(supportRequestId: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachmentsList.map((file: IFile) => {
        return this._ticketService.uploadFile(file, supportRequestId, false);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Richiesta Supporto";
    this._tutorialService.force_open_modal = true;
  }
}
